import { ACTION_PREFIX } from '../../constants';

export const USING_INSURANCE_ERROR = `${ACTION_PREFIX}/USING_INSURANCE_ERROR`;

export function usingInsuranceError(errorMessage) {
    return {
        type: USING_INSURANCE_ERROR,
        errorMessage,
    };
}
